import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-bc13edaa"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "game-panel" };
var _hoisted_2 = { class: "game-panel-inner" };
var _hoisted_3 = { class: "leaderboard" };
var _hoisted_4 = { class: "content-wrap" };
var _hoisted_5 = { class: "content" };
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "texts-wrap" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "home-title-head font-ang" }, "Miner's Rush"),
    /*#__PURE__*/ _createElementVNode("span", { class: "home-title font-ang" }, "Terms And Conditions")
], -1); });
var _hoisted_7 = { class: "col-12 col-md-12 col-xs-12" };
var _hoisted_8 = { class: "panel" };
var _hoisted_9 = { class: "panel-content" };
var _hoisted_10 = { class: "col-np-12 col-np-md-12 col-np-xs-12" };
var _hoisted_11 = ["src", "height"];
var _hoisted_12 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "top-divider" }, null, -1); });
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("iframe", {
                                            ref: "myIframe",
                                            src: $data.iframeSrc,
                                            width: "100%",
                                            height: $data.iframeHeight
                                        }, null, 8, _hoisted_11)
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                _hoisted_12
            ])
        ])
    ]));
}
